<template>
  <div>
    <router-link v-a11y-tab:tab-line :to="loginPaths">
      <a-button class="button-container log-in-button">{{ $t('login') }}</a-button>
    </router-link>
    <router-link v-a11y-tab:tab-line :to="signUpPath">
      <a-button class="button-container try-it-now-button">{{ $t('try.it.now') }}</a-button>
    </router-link>
  </div>
</template>

<script>
import { ROUTER_PATHS } from '@/router/constants';

export default {
  data() {
    return {
      loginPaths: ROUTER_PATHS.LOGIN,
      signUpPath: ROUTER_PATHS.SIGN_UP,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';

.button-container {
  height: 36px;
  width: 112px;
  font-size: $font-size-base;
  border: none;
  box-shadow: none;
  margin: 0;
}
.log-in-button {
  color: $orange;
  text-transform: capitalize;
}
.try-it-now-button {
  border-radius: $border-radius;
  background-color: $orange;
  color: $white;
}

@media (max-width: 540px) {
  .try-it-now-button {
    display: none;
  }
}
</style>
